import { render, staticRenderFns } from "./BulkPromotion.vue?vue&type=template&id=44911ee6&scoped=true"
import script from "./BulkPromotion.vue?vue&type=script&lang=js"
export * from "./BulkPromotion.vue?vue&type=script&lang=js"
import style0 from "./BulkPromotion.vue?vue&type=style&index=0&id=44911ee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44911ee6",
  null
  
)

export default component.exports